import React from "react";

interface ModuleLoaderFallbackProps {
  message?: string;
  fullScreen?: boolean;
}

const ModuleLoaderFallback: React.FC<ModuleLoaderFallbackProps> = ({
  message = "Please wait...",
  fullScreen = false,
}) => {
  return (
    <div
      className={`flex w-full items-center justify-center p-6 select-none ${
        fullScreen
          ? "fixed inset-0 z-50 bg-background/80 backdrop-blur-sm"
          : "h-full min-h-[60vh] flex-1"
      }`}
    >
      <div className="flex flex-col items-center justify-center gap-3.5">
        {/* Themed Spinner */}
        <div className="relative flex items-center justify-center w-12 h-12">
          {/* Subtle Outer Track */}
          <div
            className="absolute inset-0 rounded-full border-4 opacity-60"
            style={{
              borderColor: "#FFEDD5", // orange-100 / soft primary tint
            }}
          />
          {/* Spinning Ring */}
          <div
            className="absolute inset-0 rounded-full border-4 border-transparent border-t-[#FF6B1A] animate-spin"
            style={{
              borderTopColor: "#FF6B1A",
              borderRightColor: "transparent",
              borderBottomColor: "transparent",
              borderLeftColor: "transparent",
            }}
          />
          {/* Subtle Center Pulsing Dot */}
          <div className="w-2.5 h-2.5 rounded-full bg-[#FF6B1A] opacity-75 animate-pulse" />
        </div>

        {/* Loading Message */}
        <span className="text-sm font-medium text-slate-600 tracking-wide">
          {message}
        </span>
      </div>
    </div>
  );
};

export default ModuleLoaderFallback;
